import type { OverlayTarget, ResearchTarget } from '@/types/research';
import { DEMO_FEATURED, type DemoFeaturedEdge } from './demoFeatured.generated';

// Mobile showcase data: the headline edge (live row) plus the rest of the featured
// edges (dimmed rows), all real from the frozen demo slate with graded results.

export const [EXAMPLE, ...DEMO_ROWS] = DEMO_FEATURED;

/** "o34.5 (+100)" — the row's best line as the odds screen prints it. */
export const lineLabel = (e: DemoFeaturedEdge) =>
  `${e.side === 'over' ? 'o' : 'u'}${e.line} (${e.bestOdds})`;

/** "Hit · 48 PRA" — the graded outcome, or null when ungraded. */
export const resultLabel = (e: DemoFeaturedEdge) =>
  e.result ? `${e.result.outcome === 'win' ? 'Hit' : 'Miss'} · ${e.result.actual} ${e.marketLabel}` : null;

export const RESEARCH_TARGET: ResearchTarget = {
  playerId: EXAMPLE.playerId,
  playerName: EXAMPLE.player,
  team: EXAMPLE.team,
  imageUrl: EXAMPLE.imageUrl,
  position: EXAMPLE.position,
  opponent: EXAMPLE.opponent,
  isHome: EXAMPLE.isHome,
  marketCode: EXAMPLE.marketCode,
  marketLine: EXAMPLE.line,
  projectedMinutes: EXAMPLE.projectedMinutes,
};

// No clickedBook → the chart auto-selects the edge book plus every book that moved.
export const LINE_TARGET: OverlayTarget = {
  playerName: EXAMPLE.player,
  market: EXAMPLE.marketLabel,
  marketCode: EXAMPLE.marketCode,
  imageUrl: EXAMPLE.imageUrl,
  playerId: EXAMPLE.playerId,
  projection: EXAMPLE.projection,
  projectedMinutes: EXAMPLE.projectedMinutes,
  position: EXAMPLE.position,
  team: EXAMPLE.team,
  opponent: EXAMPLE.opponent,
  isHome: EXAMPLE.isHome,
  commenceTime: EXAMPLE.commenceTime,
  books: EXAMPLE.books,
  edge: {
    book: EXAMPLE.bestBook,
    side: EXAMPLE.side,
    line: EXAMPLE.line,
    odds: Number(EXAMPLE.bestOdds),
    ev: EXAMPLE.ev,
    pWin: EXAMPLE.pWin,
  },
  bestLines: EXAMPLE.bestLines,
};

export const PMF = EXAMPLE.pmf;
export const DEMO_MOVEMENTS = EXAMPLE.movements;
